import { render, staticRenderFns } from "./TemplateLoader.vue?vue&type=template&id=34aba796&"
import script from "./TemplateLoader.vue?vue&type=script&lang=ts&"
export * from "./TemplateLoader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports